import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

const getQueryFn =
	({
		accountId,
		offerId,
		offerUrl,
		userSession,
	}: {
		accountId: string;
		offerId?: number;
		offerUrl?: string;
		userSession: Api.UserSessionContext;
	}) =>
	async () => {
		return userSession.webServiceHelper.callAsync<string>(
			Api.ImpersonationBroker.composeApiUrl({
				queryParams: {
					offerId,
					offerUrl,
				},
				urlPath: `admin/account/${accountId}/GetSignupUrl`,
			}),
			'GET'
		);
	};

export const useGetSignUpUrl = ({
	accountId,
	offerUrl,
	offerId,
	enabled = true,
}: {
	accountId: string;
	offerUrl?: string | undefined;
	offerId?: number;
	enabled?: boolean;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: getQueryFn({ accountId, offerId, offerUrl, userSession }),
		queryKey: [`admin/account/${accountId}/GetSignupUrl`, { accountId, offerId, offerUrl }],
	});
};
